export const ALL_PLAYER_VISIBILITIES = ['visible', 'invisible', 'ninja']; // in order with respect to indexes present in inbounds
